import { graphqlRequest } from "./graphql";

export interface SharedSubscription {
  planId: string;
  serviceId: string;
  name: string;
  dp: string;
  blurhash: string;
  duration: number;
  durationType: string;
  planPrice: number;
  shareLimit: number;
  sharedPrice: number;
  discountPercentage: number;
}

interface GetSharedSubscriptionsResponse {
  getAllSharedSubscriptionsListByUser: SharedSubscription[];
}

export async function getSharedSubscriptions(
  userId: string,
  token: string
): Promise<SharedSubscription[]> {
  const query = `
    query GetSharedSubscriptions($user_id: uuid!) {
      getAllSharedSubscriptionsListByUser(request: { user_id: $user_id }) {
        planId
        serviceId
        name
        dp
        blurhash
        duration
        durationType
        planPrice
        shareLimit
        sharedPrice
        discountPercentage
      }
    }
  `;
  const data = await graphqlRequest<GetSharedSubscriptionsResponse>(
    query,
    { user_id: userId },
    token
  );
  return data.getAllSharedSubscriptionsListByUser;
}
